<ng-container *yatVar="subscriptionDetails$ | async as subscriptionDetails">
  <div class="row">
    <div class="col-12" *ngIf="subscriptionDetails">
      <h2 class="mb-2 text-sm font-normal text-n-40">
        <span class="mr-2"
          ><transloco
            id="7689d4fe-59fc-4bdb-89b6-37f502cef9f0"
            [key]="
              (subscriptionBookingStatus$ | async) === 'BOOKED' ? 'subscriptionManagement.overview.firstPayment' : 'subscriptionManagement.overview.nextPayment'
            "
            [params]="{
              pricingInformation: subscriptionDetails.pricingInformation.total | translocoCurrency: 'symbol':{}:subscriptionDetails.pricingInformation.currency
            }"></transloco></span
        ><transloco
          id="21de4b34-3867-494e-b37d-71a51eaf4ab9"
          key="subscriptionManagement.overview.paymentOn"
          [params]="{
            endOfPeriod: subscriptionDetails.endOfPeriod | translocoDate
          }"></transloco>
      </h2>
    </div>
  </div>

  <div class="row mb-[16px]">
    <div class="col-12">
      <yat-payment-method-panel
        id="6ab2d6f7-3f8f-42d6-9568-357c7a9ecc8d"
        *ngIf="connectedPaymentMethod$ | async as connectedPaymentMethod; else noPaymentMethodSelected"
        [paymentMethod]="connectedPaymentMethod"
        defaultIcon="settings"
        [showEditIcon]="false"
        [showDeleteIcon]="false"
        [liveLicense]="(isLive$ | async) ?? true"
        [minified]="true"
        (selectMethod)="managePaymentMethod()"
        matomoEventClickAction="Modify_PaymentMethod">
      </yat-payment-method-panel>
      <ng-template #noPaymentMethodSelected>
        <div class="panel-div"></div>
      </ng-template>
    </div>
  </div>
  <h2 class="mb-2 text-sm font-normal text-n-40" *ngIf="(billingAddressRequired$ | async) || (connectedBillingAddress$ | async) !== null">
    {{ 'billingAddressTitle' | commonBillingWording | async }}
    <yat-tooltip-info-icon
      iconClass="ml-1"
      tooltipClass="tooltip-xl"
      tooltipContent="{{ 'subscriptionManagement.overview.billingInformationTooltip' | transloco }}">
    </yat-tooltip-info-icon>
  </h2>
  <div class="row mb-4">
    <div class="col-12">
      <ng-container *ngIf="connectedBillingAddress$ | async as connectedBillingAddress; else noBillingAddressSelected">
        <yat-billing-address-panel
          id="b8956835-ec67-4a5a-8c9b-20fa3ca40f2a"
          [billingAddress]="connectedBillingAddress"
          defaultIcon="settings"
          [showEditIcon]="false"
          [showDeleteIcon]="false"
          [liveLicense]="(isLive$ | async) ?? true"
          [minified]="true"
          (selectAddress)="manageBillingAddress()"
          matomoEventClickAction="Modify_BillingAddress">
        </yat-billing-address-panel>
      </ng-container>
      <ng-template #noBillingAddressSelected>
        <yat-no-billing-address-selected-panel
          id="40f2c28f-57fc-41e4-b166-52896b9ccdfd"
          (createFirstAddress)="createBillingAddress()"
          (selectExistingAddress)="manageBillingAddress()">
        </yat-no-billing-address-selected-panel>
      </ng-template>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <button
        yat-button
        type="button"
        class="btn btn-large primary w-100"
        (click)="close()"
        [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PURCHASE"
        matomoClickAction="Dismiss_SubscriptionOverview">
        {{ 'close' | commonWording | async }}
      </button>
    </div>
  </div>
  <div class="row mtop-12">
    <div class="col-12 text-center font-weight-bold">
      <button
        *ngIf="(subscriptionBookingStatus$ | async) === 'EXPIRING'; else cancelButton"
        yat-button
        (click)="switchToResubscribe()"
        class="btn btn-large secondary-weak w-100"
        [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PURCHASE"
        matomoClickAction="Confirm_Resubscribe">
        {{ 'subscriptionManagement.overview.resubscribe' | transloco }}
      </button>
      <ng-template #cancelButton>
        <button
          yat-button
          routerLink="../cancel-subscription"
          class="btn btn-large secondary-weak w-100"
          [matomoClickCategory]="MATOMO_EVENT_CATEGORY_PURCHASE"
          [matomoClickAction]="(isLive$ | async) ? 'Confirm_CancelSubscription' : 'Confirm_CancelDemoSubscription'">
          {{ 'subscriptionManagement.overview.cancelSubscription' | transloco }}
        </button>
      </ng-template>
    </div>
  </div>
</ng-container>
